import { apiClient } from '../constants'

export const signIn = (user: AuthSigninPayload) => apiClient.post('oauth/sign_in', user)
export const signUp = (user: AuthSignupPayload) => apiClient.post('oauth/register', { user })
export const signOut = () => apiClient.delete('oauth/sign_out')
export const requestPasswordReset = (email: string) => apiClient.post('oauth/password_reset_request', { email })
export const resetPassword = (oauth: AuthPasswordResetPayload) => apiClient.post('oauth/password_reset', { oauth })
export const getCurrentUser = () => apiClient.get<User>('current_user')
export const updateCurrentUser = (user: UserUpdatePayload) => apiClient.patch<User>('current_user', { user })
